import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const hoursByDay = {
    0: ['Open Mon', '9AM'], // Sunday
    1: ['Available until', '5PM'], // Monday
    2: ['Available until', '5PM'], // Tuesday
    3: ['Available until', '5PM'], // Wednesday
    4: ['Available until', '5PM'], // Thursday
    5: ['Available until', '5PM'], // Friday
    6: ['Open Mon', '9AM'], // Saturday
};

export default function Footer() {

    const [todayHours, setTodayHours] = useState({ label: '', time: '' });
    useEffect(() => {
        const today = new Date().getDay();
        setTodayHours({
            label: hoursByDay[today as keyof typeof hoursByDay][0],
            time: hoursByDay[today as keyof typeof hoursByDay][1]
        });
    }, []);
    return (
        <footer>
            <div className="container">
                <div className="footer-wrapper">
                    <div className="footer-column">
                        <div className="logo">
                            <Link to="/" rel="nofollow">CompareYachtCharters</Link>
                        </div>
                    </div>
                    <div className="footer-column socials">
                        <ul className="footer-links">
                            <li>
                                <a
                                    href="https://www.instagram.com/compare_yachtcharters"
                                    target="_blank"
                                    rel="noreferrer" >
                                    <i className="fa-brands fa-instagram"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.facebook.com/compareyachtcharters/" aria-label="Facebook" target="_blank" rel="nofollow">
                                    <i className="fa-brands fa-facebook"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://x.com/compareyachtc" aria-label="X" target="_blank" rel="nofollow">
                                    <i className="fa-brands fa-x-twitter"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.youtube.com/@compareyachtcharters" aria-label="Youtube" target="_blank" rel="nofollow">
                                    <i className="fa-brands fa-youtube"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.tiktok.com/@compareyachtcharters" aria-label="TikTok" target="_blank" rel="nofollow">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                        {/* <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--> */}
                                        <path d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z" /></svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                    {/* <div className="footer-column">
                        <div className="tel-block">
                            <h6>
                                <a className="tel-num" href="tel:+4402078811234" rel="nofollow">
                                    0207 881 1234
                                </a>
                            </h6>
                            <p className="tel-info">
                                We’re here to answer your questions and plan your holidays
                            </p>
                            <p className="hours-row mobile">Lines open today 9am-8pm</p>
                        </div>
                    </div> */}
                </div>

                <div className="subfooter-wrapper">
                    <div className="subfooter-links-block">
                        <ul className="subfooter-links">
                            <li className="subfooter-link">
                                <Link rel="nofollow" to="/about-us" >About Us</Link>
                            </li>
                            <li className="subfooter-link">
                                <Link rel="nofollow" to="/privacy-policy" >
                                    Privacy &amp; Cookies Policy
                                </Link>
                            </li>
                            <li className="subfooter-link">
                                <Link rel="nofollow" to="/terms">Website Terms</Link>
                            </li>
                        </ul>
                        {/* <p className="hours-row opening-hours">
                            <span className="top-line">
                                {todayHours.label} <strong className="bold">{todayHours.time}</strong>
                            </span>
                        </p> */}
                    </div>
                    <div className="subfooter-additional-info">
                        <div className="text">
                            <p style={{ marginBottom: '10px' }}>
                                At CompareYachtCharters.com, we make it simple to find the ideal yacht charter for your next getaway.
                                By bringing together thousands of yacht listings with local insights, suggested itineraries and inspiration,
                                we offer one of the most complete resources available for planning your perfect charter experience.
                                <span className="atol">
                                    Our ATOL number is
                                    <strong>ATOL XXXX</strong>.
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}